// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".avatar-text[data-v-7a8d88ef]{font-family:outfit-medium;margin-right:12px;padding:8px;line-height:20px;margin-top:0;margin-bottom:0;border-radius:30%;width:20px;height:20px;font-size:14px;text-align:center;color:#0b42b0;background-color:rgba(11,66,176,.1);-ms-flex-negative:0;flex-shrink:0;-webkit-box-sizing:content-box;box-sizing:content-box}.circle[data-v-7a8d88ef]{border-radius:50%}", ""]);
// Exports
module.exports = exports;
